import { useContext, useEffect, useState } from 'react';
import AuthenticationContext from '../../../contexts/auth/AuthenticationContext';
import CompanyContext from '../../../contexts/company/CompanyContext';
import { getConversationCallRecording } from '../../../../domain/use_cases/conversations/getConversationCallRecording';

// Same as useReceptionistCallRecordingController, for any call of a conversation
const useConversationCallRecordingController = (subscriptionId: string, callId: string, hasRecording: boolean) => {
  const { authentication } = useContext(AuthenticationContext);
  const { activeCompany } = useContext(CompanyContext);

  const [recording, setRecording] = useState<{ callId: string; url: string } | null>(null);

  const [failedCallId, setFailedCallId] = useState<string | null>(null);

  const companyId = activeCompany?.id;
  const isLoaded = recording?.callId === callId;
  const hasFailed = failedCallId === callId;

  useEffect(() => {
    if (!hasRecording || isLoaded || hasFailed || !companyId || !authentication) return;

    let isCancelled = false;
    getConversationCallRecording({ company_id: companyId, subscription_id: subscriptionId, call_id: callId }, authentication)
      .then((response) => {
        if (!isCancelled) setRecording({ callId, url: response.recording_url });
      })
      .catch(() => {
        if (!isCancelled) setFailedCallId(callId);
      });
    return () => {
      isCancelled = true;
    };
  }, [hasRecording, isLoaded, hasFailed, subscriptionId, callId, companyId, authentication]);

  return {
    state: {
      url: isLoaded ? recording.url : '',
      isLoading: hasRecording && !isLoaded && !hasFailed,
      hasFailed,
    },
  };
};

export default useConversationCallRecordingController;
